import React, { useState } from 'react';
import Card from 'react-bootstrap/Card';
import { Profile } from '../../types';
import Avatar, { AvatarSize, AvatarStatus } from '../Avatar';
import Checkbox from '../Checkbox/Checkbox';

export type UserCardProps = {
  item: Profile;
  className?: string;
  onClick?: React.MouseEventHandler;
  selected?: boolean;
};

const UserCard = ({ item, className, onClick, selected }: UserCardProps) => {
  const { id, value, name, image, relationship, firstName } = item;
  const [isSelected, setSelected] = useState(
    selected !== undefined ? selected : false
  );

  const handleToggle = (e?: any) => {
    setSelected((prevOpen) => !prevOpen);
    onClick && onClick(e);
  };

  const handleSelect = () => {
    setSelected(!isSelected);
  };

  const handleClass = () => {
    let className = '';

    if (selected !== undefined) {
      className = selected ? 'selected' : '';

      return className;
    }

    className = isSelected ? 'selected' : '';
    return className;
  };

  return (
    <Card
      bsPrefix={'cnd-user-card'}
      onClick={handleToggle}
      className={`d-flex flex-lg-column align-items-center position-relative ${className} ${handleClass()} `}
    >
      <Checkbox
        value={value}
        className={'position-absolute'}
        checked={selected !== undefined ? selected : isSelected}
        onChange={handleSelect}
      />
      <div
        className={
          'cnd-user-card--image-wrapper d-flex justify-content-center align-items-center'
        }
      >
        <Avatar
          id={id}
          size={AvatarSize.LARGE}
          image={image}
          status={AvatarStatus.ENABLED}
          name={name}
        />
      </div>
      <Card.Body className={'d-flex flex-column align-items-lg-center'}>
        <Card.Title>{relationship === 'self' ? 'You' : firstName}</Card.Title>
        <Card.Subtitle>
          {relationship === 'self' ? 'Organizer' : relationship}
        </Card.Subtitle>
      </Card.Body>
    </Card>
  );
};

export default UserCard;
